import React from 'react';
import { motion } from 'framer-motion';
import { Play } from '@phosphor-icons/react';
interface PitchActionsProps {
  onPlay: () => void;
  onStoryboard: () => void;
  onConcept: () => void;
  onSignals: () => void;
}
export function PitchActions({
  onPlay,
  onStoryboard,
  onConcept,
  onSignals
}: PitchActionsProps) {
  return <div className="flex flex-wrap items-center gap-2.5" data-id="element-171" data-mp="2zhw5ayuwvz8m">
      <motion.button type="button" onClick={onPlay} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30
    }} className="inline-flex items-center gap-2.5 rounded-full bg-background px-7 py-4 font-body text-[15px] font-medium tracking-[-0.01em] text-white shadow-[0_18px_40px_-20px_rgba(1,51,43,0.65)] transition-colors hover:bg-[#02463b] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-172" data-mp="3diqevktp468v">
        <Play size={16} weight="fill" aria-hidden="true" data-id="element-173" data-mp="3s9pmasisooqv" />
        Play the Snak
      </motion.button>

      <SecondaryAction onClick={onStoryboard} data-id="element-174" data-mp="3809ota3x6tjw">Storyboard</SecondaryAction>
      <SecondaryAction onClick={onConcept} data-id="element-175" data-mp="3cyjkdltk3w61">Concept &amp; strategy</SecondaryAction>
      <SecondaryAction onClick={onSignals} data-id="element-176" data-mp="3gyu2fwumid19">What we learn</SecondaryAction>
    </div>;
}
function SecondaryAction({
  children,
  onClick
}: {
  children: React.ReactNode;
  onClick: () => void;
}) {
  return <motion.button type="button" onClick={onClick} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} transition={{
    type: 'spring',
    stiffness: 500,
    damping: 30
  }} className="inline-flex items-center rounded-full border border-[rgba(1,51,43,0.2)] px-5 py-4 font-body text-[14px] tracking-[-0.01em] text-[rgba(1,51,43,0.75)] transition-colors hover:border-[rgba(1,51,43,0.55)] hover:text-background focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-177" data-mp="3qw876z76pddq">
      {children}
    </motion.button>;
}